import { useCallback, useSyncExternalStore } from "react";
import { clearAuthSession, getSessionExpiry, getStoredSession, logout as apiLogout } from "../api/auth";

const subscribe = (callback) => {
  window.addEventListener("storage", callback);
  return () => window.removeEventListener("storage", callback);
};

export default function useAuthToken() {
  const session = useSyncExternalStore(subscribe, getStoredSession);
  const expiry = getSessionExpiry();
  const isAuthenticated = Boolean(session);

  const logout = useCallback(async () => {
    try {
      await apiLogout();
    } catch {
      // Ignore logout failures; clear local session state regardless.
    }
    clearAuthSession();
    window.dispatchEvent(new Event("storage"));
  }, []);

  return { isAuthenticated, expiry, logout };
}
